export default "__VITE_ASSET__B$Zw_7aD__"